import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/cadastro")({
	validateSearch: (
		// biome-ignore lint/suspicious/noExplicitAny: TODO
		search: Record<string, any>,
	): { representanteIdpk?: string } => ({
		representanteIdpk: search?.representanteIdpk,
	}),
});
